import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#EEDEBB',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#900028',
      contrastText: '#fff'
    },
    secondary: {
      main: '#B17D58',
      contrastText: '#fff'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography
});

export default theme;
